import React from 'react';
import PageSection from 'components/PageSection';
import LicenseStatus from './LicenseStatus';
import LicenseKeys from './LicenseKeys';
import LicenseRequestHistory from './LicenseRequestHistory';
import './LicenseStatus.css';
import './LicenseKeys.css';
import './LicenseRequestHistory.css';

const SystemLicensingPage = () => {
  return (
    <div>
      <PageSection title="Software Licensing" level={2}>
        <p>Manage your software license keys and monitor licensing status</p>
      </PageSection>
      
      <PageSection title="License Status" level={3}>
        <LicenseStatus />
      </PageSection>

      <PageSection title="License Keys" level={3}>
        <LicenseKeys />
      </PageSection>

      <PageSection title="License Request History" level={3}>
        <LicenseRequestHistory />
      </PageSection>
    </div>
  );
};

export default SystemLicensingPage;
